import React, { HTMLAttributes } from 'react';
import { View } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import './style.scss';
import { ParagraphPartnersOverview as Type } from '../../../types/uncinc_profile/paragraphs';
import { WysiwygField } from '../../../components';

interface ParagraphPartnersOverviewProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphPartnersOverview: React.FC<ParagraphPartnersOverviewProps> = ({ entity }) => {
  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;

  return (
    <div id={uuid} className="ParagraphPartnersOverview">
      {title && <h2>{title}</h2>}
      {body && (
      <WysiwygField
        html={body}
        classes="ParagraphPartnersOverview__body"
      />
      )}
      <View
        id="partners"
        display="overview"
      />
    </div>
  );
};

export default ParagraphPartnersOverview;
